import { resendPartnerInvite, type PartnerProfile } from "../../Lib/partnerApi";

export type InvitationMethod = "copy" | "email";

export async function sharePartnerInvitation(partner: PartnerProfile, method: InvitationMethod) {
    const result = await resendPartnerInvite(partner.id);
    if (method === "copy") {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(result.invitationUrl);
        else window.prompt("Copy this invitation link", result.invitationUrl);
        return `A fresh invitation link for ${partner.name} was copied to your clipboard.`;
    }

    const subject = "Your MockZo Partner invitation";
    const body = `Hi ${partner.name},\n\nYou have been invited to join the MockZo Partner workspace.\n\nActivate your account using this secure link:\n${result.invitationUrl}\n\nPlease sign in with ${partner.email}. This invitation expires in 14 days.\n\nRegards,\nMockZo Team`;
    window.location.href = `mailto:${encodeURIComponent(partner.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return `A fresh invitation for ${partner.name} was opened in your email app.`;
}
